module.exports = __webpack_public_path__ + "static/media/Ram.103c4ba4.jpg";